export default __webpack_public_path__ + "static/media/Sunset Blade.35c3a9d6.png";